import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://gsxttfuubnxlyvertacd.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdzeHR0ZnV1Ym54bHl2ZXJ0YWNkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDAyODQ5ODQsImV4cCI6MjAxNTg2MDk4NH0.kWcsaVxvNkW4femYiAYcOCvh_U6U0tm1alYaE5r2Ioc"
);

export default supabase;
